import { z } from 'zod';
import { IObject } from '../IObject';
import { EmailEventDataSchema, EmailBaseSchema } from '../emails';
import { EmailEventRecordType } from '../enums';

export const EbpCaseEmailDataSchema = EmailBaseSchema.extend({
  caseId: z.string().optional(),
  // Whatever the provider named the latest event of this email — a record
  // type we do not know yet is still stored (see EmailEventDataSchema)
  status: z.custom<EmailEventRecordType>(
    (value) => value !== undefined && value !== null,
    'status is required',
  ),
  events: z.array(EmailEventDataSchema).optional(),
  documentId: z.string().optional(),
});

export type EbpCaseEmailData = z.infer<typeof EbpCaseEmailDataSchema>;
export type EbpCaseEmail = IObject.HasIdTimestamped<EbpCaseEmailData>;
